import { get, uniq } from 'lodash';
import React from 'react';

import {
  FormikInput,
  FormikRadioButton,
  FormikDatepicker,
  FormikFileUploader,
  FormikErrorMessage
} from '@src/features/common';
import { Yup, validateFormikField } from 'src/helpers';

import { LayoutBox, Flex, Text } from 'src/kit';

export const CustomQuestion = ({ question, index, values, ...styledProps }) => {
  const fieldName = `custom_answers.${index}`;
  const currentValue = get(values, fieldName);
  const customQuestion = getCustomQuestionByType({ fieldName, question, currentValue });
  return (
    <LayoutBox as="div" p={0} display="block" {...styledProps}>
      <Text mb={10}>
        {index + 1}. {question.text}
      </Text>
      {!question.required && (
        <Text mb={10} color="#a4b0b8" fontWeight="light">
          Optional
        </Text>
      )}
      {customQuestion}
    </LayoutBox>
  );
};

const getCustomQuestionByType = ({ fieldName, question, currentValue }) => {
  const validate = getValidationFn(question);

  switch (question.type) {
    case 'number': {
      return <FormikInput name={fieldName} validate={validate} />;
    }
    case 'text': {
      return (
        <FormikInput
          as="textarea"
          name={fieldName}
          validate={validate}
          label={
            question.max_words && (
              <Flex justifyContent="flex-end">
                <div>{question.max_words - (currentValue?.split(' ').length || 0)}</div>
              </Flex>
            )
          }
          size="baseTextarea"
          inputProps={{ height: 120 }}
        />
      );
    }
    case 'date': {
      return (
        <FormikDatepicker name={fieldName} validate={validate} dateFormat="DD.MM.YYYY" variant="primary" size="md" />
      );
    }
    case 'boolean': {
      return (
        <>
          <Flex alignItems="center">
            <FormikRadioButton showError validate={validate} id={true} name={fieldName} mr={20}>
              Yes
            </FormikRadioButton>
            <FormikRadioButton validate={validate} id={false} name={fieldName}>
              No
            </FormikRadioButton>
          </Flex>
          <FormikErrorMessage name={fieldName} />
        </>
      );
    }
    case 'multiple_choice': {
      return (
        <div>
          {uniq(question.choice_options || []).map((option, index) => (
            <FormikRadioButton key={index} id={option} name={fieldName} mb={5}>
              {option}
            </FormikRadioButton>
          ))}
        </div>
      );
    }
    case 'file': {
      return (
        <FormikFileUploader
          maxFileSize={'10MB'}
          allowedExtensions={['pdf', 'doc', 'docx', 'jpg', 'jpeg', 'gif', 'png']}
          validate={validate}
          name={fieldName}
          text="Drag and drop your file anwser here"
          mb={5}
        />
      );
    }
    default: {
      return null;
    }
  }
};

const getValidationFn = ({ type, required, max_words }) => {
  let schema = type === 'number' ? Yup.number().typeError('You should specify a number') : Yup.string();
  if (required) {
    schema = schema.required(`This question is required`);
  }
  if (max_words) {
    schema = schema = schema.maxWords(max_words, 'This answer');
  }

  return validateFormikField(schema);
};

export const validateCustomQuestion = getValidationFn;
